import React, {
  useState,
  useContext,
  useEffect,
} from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import ContractModalContext from '../../context/ContractModalContext';
import UserInfoSection from '../../UserInfoSection/UserInfoSection';
import ContractModalFooter from '../../ContractModalFooter';
import ContractEditor from '../../ContractEditor';
import SendOnboardingLinkModal from '../SendOnboardingLinkModal';

import {
  Container,
  Header,
} from './styles';

const LeadContractModalContent = ({
  lead,
  coachId,
  onClose,
  showSendLinkOption,
  showPostCommitmentConfiguration,
}) => {
  const [showSendOnboardingLinkModal, setShowSendOnboardingLinkModal] = useState(false);

  const {
    isReadOnly,
    setCoachId,
    loadContractByLead,
    onboardingLinkRecipient,
    onboardingLink,
  } = useContext(ContractModalContext);

  useEffect(() => {
    if (coachId) {
      setCoachId(coachId);
    }
  }, [
    coachId,
    setCoachId,
  ]);

  useEffect(() => {
    if (lead?.id) {
      loadContractByLead(lead);
    }
  }, [
    lead,
    loadContractByLead,
  ]);

  return (
    <Container>
      <Header>
        <UserInfoSection userData={lead} />
      </Header>
      <ContractEditor showPostCommitmentConfiguration={showPostCommitmentConfiguration} />
      {!isReadOnly && (
        <ContractModalFooter
          onSendLink={() => setShowSendOnboardingLinkModal(true)}
          showSendLinkOption={showSendLinkOption}
        />
      )}
      {showSendOnboardingLinkModal && !!onboardingLinkRecipient && (
        <SendOnboardingLinkModal
          recipient={onboardingLinkRecipient}
          onboardingLink={onboardingLink}
          showModal={showSendOnboardingLinkModal}
          onClose={() => setShowSendOnboardingLinkModal(false)}
          onLinkSent={onClose}
        />
      )}
    </Container>
  );
};

LeadContractModalContent.propTypes = {
  lead: PropTypes.object.isRequired,
  coachId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  showPostCommitmentConfiguration: PropTypes.bool.isRequired,
  showSendLinkOption: PropTypes.bool,
};

LeadContractModalContent.defaultProps = {
  showSendLinkOption: false,
};

export default compose(
  observer,
)(LeadContractModalContent);
